import styled from 'styled-components';
export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  width: 100%;
  height: 52px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #0f5192;
  z-index: 10;
`;

export const LogoBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const Title = styled.h1`
  width: 100%;
  font-size: 36px;
  font-weight: 700;
`;

export const MenuWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 20px;
  color:#fff;
  gap: 5px;

  &:hover {
    color:#ddd;
  }
`;

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  font-weight: 700;
  color: white;
  text-align: center;
  width: 150px;
  height: 100%;
  cursor: pointer;
`;

export const AdminText = styled.div`
  font-size: 22px;
  color: white;
  font-weight: 100;
`;
